if (!customElements.get('ia-how-to-use')) {

class IaHowToUse extends HTMLElement {
  constructor() {
    super();
    
    this.buttons = this.querySelectorAll('.js-add-all-to-cart');
    this.buttons.forEach(button => {
      button.addEventListener('click', this.addAllToCart.bind(this));
    });

    this.miniCart = document.querySelector('mini-cart');
    
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
    
    this.querySelectorAll('add-to-cart').forEach(addToCart => {
      addToCart.addEventListener('click', (e) => {
        addToCart.querySelector('.js-atc-text')?.classList.add('hidden');
        addToCart.querySelector('.js-atc-text-adding')?.classList.remove('hidden');
      });
    })

    document.addEventListener('cart:allChanges', (e) => {
      this.querySelectorAll('add-to-cart').forEach(addToCart => {
        addToCart.querySelector('.js-atc-text').classList.remove('hidden');
        addToCart.querySelector('.js-atc-text-adding')?.classList.add('hidden');
      });
    });
  }

  connectedCallback() {
    
  }

  addAllToCart() {
    this.buttons.forEach(button => {
      button.setAttribute('disabled', true);
      button.classList.add('loading');
    });
    
    const items = [];
    const products = this.querySelectorAll('.js-how-to-use-item add-to-cart');

    products.forEach(product => {
      const variantId = product.dataset.variantId;
      if (variantId && !items.some(item => item.id === variantId)) {
        items.push({ id: variantId, quantity: 1 });
      }
    });
    
    if (items.length === 0) {
      this.buttons.forEach(button => {
        button.classList.remove('loading');
        button.removeAttribute('disabled');
      });
      this.button.removeAttribute('disabled');
      console.error('>>> IA How To Use: No valid variants selected.', items);
      return;
    }

    const payload = { items: items, sections: ['mini-cart'] };
    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map(section => section.id) : [];
    const body = JSON.stringify({
      ...payload,
      sections,
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(response => {
        if (response.status === 422) {

        } else {
          this.miniCart && this.miniCart.renderContents(response);

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: response
            }
          }));
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.buttons.forEach(button => {
          button.classList.remove('loading');
          button.removeAttribute('disabled');
        });
      });
  }
  handleVariantChange(event) {
    console.log('>>> IA How To Use: handleVariantChange', event);
    if (event.detail.section !== this.dataset.section) return;
    const variant = event.detail.variant;
    const id = variant.id;

    document.querySelectorAll('.js-how-to-use-item add-to-cart').forEach(addToCart => {
      if (addToCart.dataset.url === event.detail.url) {
        addToCart.dataset.variantId = id;
      }
    })

  }
}
customElements.define('ia-how-to-use', IaHowToUse);
}